/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

	//sticky header
	var scrollThreshold = 10;
	var $header = $('#section-header')
    $(window).scroll(function(){
      if($(window).scrollTop() <= scrollThreshold && jQuery(window).scrollTop() <= 0){
      	$header.removeClass('Header--sticky')
      }
      else{
        if($(window).scrollTop() > scrollThreshold && jQuery(window).scrollTop() > 0){
        	$header.addClass('Header--sticky')
        }
      }
    });

// Slideshow progress 

  $(".Slideshow__Carousel").on("init reInit afterChange beforeChange", function (event,slick,currentSlide,nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var index = currentSlide ? currentSlide : 0;

    var autoplaySpeed = slick.slickGetOption("autoplaySpeed");
    var speed = slick.slickGetOption("speed");
    var controller = $(".slider-dots-box");
    var slider = $(".Slideshow__Slide");
    var r = 9;
    var stroke = 1;
    var width = r * 2 + stroke;
    var anchor = width / 2;
    var rlen = 2 * Math.PI * r;

    if (event.type == "init") {
      var current_html = "";
      for (let i = 1; i <= slick.slideCount; i++) {
        current_html += "<button>";
        current_html +=
          '<svg class="progress" width="' +
          width +
          '" height="' +
          width +
          '"><circle r="' +
          r +
          '" cx="' +
          anchor +
          '" cy="' +
          anchor +
          '" style="stroke-dasharray: ' +
          rlen +
          "px; stroke-dashoffset: " +
          rlen +
          "px; stroke-width: " +
          stroke +
          'px"/></svg>';
        current_html += "<span>" + i + "</span>";
        current_html += "</button>";
      }
      controller.html(current_html);
      controller.children().eq(index).find("circle").stop().animate(
        {
          "stroke-dashoffset": "0px"
        },
        autoplaySpeed
      );

      controller.find("button").each(function (item, index) {
        $(this).click(function () {
          slick.slickGoTo(item);
        });
      });
      // 14 June '24 StoreHero作業: Slideshowのzoomエフェクトをオフ
      // var image = slider.eq(index).find(".Slideshow__Image");
      // image.addClass("animate_scale");
    }
    if (event.type == "beforeChange") {
      var target = controller.children().eq(index).find("circle");
      // slider.eq(nextSlide).find(".Slideshow__Image").addClass("animate_scale");
      target.css({
        "stroke-dashoffset": "0px"
      });
      target.stop().animate(
        {
          "stroke-dashoffset": -rlen + "px"
        },
        speed
      );
    }
    if (event.type == "afterChange") {
      var target = controller.children().eq(index).find("circle");
      var prevIndex = index - 1 < 0 ? slick.slideCount - 1 : index - 1;
      // slider.eq(prevIndex).find(".Slideshow__Image").removeClass("animate_scale");
      target.css({
        "stroke-dashoffset": rlen + "px"
      });
      target.stop().animate(
        {
          "stroke-dashoffset": "0px"
        },
        autoplaySpeed
      );
    }
  });

// *Temporary fix due to a bug in slick and css calc() in instagram webview*
$(document).ready(function(){
  var slickOptions = {
        arrows: false,
        infinite: true,
        dots: false,
        draggable: true,
        focusOnSelect: true,
        autoplay: true,
        autoplaySpeed:7000,
        pauseOnHover: false,
        pauseOnFocus: false,
        fade:true
      };

  if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
    if (navigator.userAgent.match(/Instagram/)) {
        window.setTimeout(function(){
	      $('.Slideshow__Carousel').css('height', (window.innerHeight - 38)+'px');
	      $('.Slideshow__Carousel').slick(slickOptions);
          $('.Slideshow__ImageContainer').css('height', (window.innerHeight - 38)+'px');
        }, 500);
      } else {
          $('.Slideshow__Carousel').slick(slickOptions);
      }
  } else {
    $('.Slideshow__Carousel').slick(slickOptions);
  }
});

  // End Slideshow progress

  $('.Section-featured--collections:not(.Section-featured--collections--2) .ProductList').slick({
    arrows: true,
    infinite: false,	
    dots: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '107px',
          centerMode: true,
        }
      }
    ]
  });

  $('.Section-featured--collections--2 .ProductList').slick({
    arrows: true,
    infinite: false,	
    dots: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  $('.Section-preOrder--collections .ProductList').slick({
    arrows: true,
    infinite: false,	
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 2,
  });

  $('.Section--blogpost .ArticleList--carousel').slick({
    arrows: true,
    infinite: false,	
    dots: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  $('.Product__Info-related-posts .Product__Info-related-posts-list').slick({
    arrows: true,
    infinite: false,	
    dots: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  //custom recommendations
   var recommendations = setInterval((function() {
          $(".rktheme-product-price-wrap").length && (clearInterval(recommendations),
          setTimeout((function() {
              $(".rktheme-product-price-wrap .rktheme-product-price.rktheme-product-price--compare").append('<span class="taxPrice">(税込)</span>'),
              $(".rktheme-product-price-wrap .rktheme-product-price.rktheme-product-price--original").append('<span class="taxPrice">(税込)</span>')
          }), 200)) 
      }
   ), 100);

	//slider Gallery
  function showSliderGallery (){
    if($(window).width() <= 768){
      $('.jsGallerySp').not(".slick-initialized").slick({
        arrows: false,
        infinite: true,	
        dots: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '50px',
        centerMode: true
      });
      $('.c-rows__col .SectionHeader__Link').parent().remove();
    
    } else{
      $(".jsGallerySp").hasClass("slick-initialized") && $(".jsGallerySp").slick("unslick")
    }
  }

  showSliderGallery();
  $(window).on('resize', function(){
    showSliderGallery();
  });

  $('.jsCarouselArea').slick({
    arrows: true,
    infinite: false,	
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '45px',
          centerMode: true
        }
      }
    ]
  });
  //shop now
  if($('.jsShopNow').length > 0 ){
    $('.jsShopNow').slick({
      arrows: true,
      infinite: false,	
      dots: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  }
	
  var productRecommendations = setInterval((function() {
    $('.jsProductRecommendations').length && (clearInterval(productRecommendations),
     setTimeout((function() {
      $('.jsProductRecommendations').slick({
        arrows: true,
        infinite: false,	
        dots: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      }); 
    }), 200)) 
  }), 100);

  $(document).ready(function() {
    // product 
    $('.ProductForm__Option select option').each(function() {
        const dataValue = $(this).val();
        var $this = $(this);
        $('.Product__Variants .c-Variants').each(function() {
            var dataAvailable = $(this).attr('data-variant-id');
            if (dataValue == dataAvailable && $this.attr('disabled')) {
                $('.c-Variants__AddToCart').attr('disabled', 'disabled'); // 無効にする
                $('.c-outOfstock').css('display', 'block'); // 表示する
            } else {
                $('.c-Variants__AddToCart').removeAttr('disabled'); // 有効にする
                $('.c-outOfstock').css('display', 'none'); // 非表示にする
            }
        });
    });

    function checkAvailablePr() {
        $('.Product__Variants').find('.c-Variants').each(function() {
            if ($('.c-Variants__options span').length >= 1) {
                var dataAvailable = $(this).find('.c-Variants__options span').data('available');
                var $this = $(this);
                if (dataAvailable == false) {
                    $this.find('.c-Variants__BuyProduct a.c-Variants__AddToCart').attr('disabled', 'disabled');
                    $this.find('.c-Variants__BuyProduct a.c-outOfstock').css('display', 'block'); // 表示する
                } else {
                    $this.find('.c-Variants__BuyProduct a.c-Variants__AddToCart').removeAttr('disabled');
                    $this.find('.c-Variants__BuyProduct a.c-outOfstock').css('display', 'none');
                }
            }
        });
    }

    checkAvailablePr();

    $('#zooomybackinstock').css({
        'cssText': 'display: none !important'
    });

    $('.c-outOfstock').on('click', function() {
        var $this = $(this);
        $('.c-outOfstock').removeClass('is-active');
        $this.addClass('is-active');
        $('.ProductForm__Option select option').each(function() {
            var variantId = $this.parent().parents('.c-Variants').attr('data-variant-id');
            var variantSelect = $(this).val();
            var newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?variant=").concat(variantId);
            window.history.replaceState({
                path: newUrl
            }, '', newUrl);
            if ($('input.zooomybisalert').length) {
                $('input.zooomybisalert').val(variantId);
            }
            if (variantSelect == variantId) {
                $(this).attr('selected', 'selected');
            } else {
                $(this).removeAttr("selected");
            }
        });
        $('.single-option-selector').trigger("change");
        setTimeout(function() {
            // 2023.5.31 Add : Activate Back in Stock app
            $('#BIS_trigger').click();
            $('#zooomybackinstock').css({
                'cssText': 'display: block !important'
            });
        }, 300);
    });

    $('.c-Variants__options select').on('change', function() {
        var valueOption = $(this).val();
        var $this = $(this).parent().parent();
        $this.attr('data-variant-id', valueOption);
        $this.find('.c-Variants__BuyProduct a').attr('data-id', valueOption);
        var checkAvailable = $('#' + valueOption).attr('data-available');
        var dataVariantId = $this.attr('data-variant-id');
        if ($('.c-VariantsInventory').length) {
            const inventoryQuantity = $(this).find('option:selected').data('quantity');
            if (inventoryQuantity >= 4 || inventoryQuantity === 0) {
                $(this).parent().parent().find('.c-VariantsInventory').hide();
            } else {
                $(this).parent().parent().find('.c-VariantsInventory').show();
            }
        }
        if ($('input.zooomybisalert').length) {
            $('input.zooomybisalert').val(dataVariantId);
        }
        $('#zooomybackinstock').css({
            'cssText': 'display: none !important'
        });
        if (checkAvailable == 'false') {
            $this.find('.c-Variants__BuyProduct a.c-Variants__AddToCart').attr('disabled', 'disabled');
            $this.find('.c-Variants__BuyProduct a.c-outOfstock').css('display', 'block'); // 表示する
            $('.c-outOfstock').removeClass('is-active');
        } else {
            $this.find('.c-Variants__BuyProduct a.c-Variants__AddToCart').removeAttr('disabled');
            $this.find('.c-Variants__BuyProduct a.c-outOfstock').css('display', 'none');
        }
        var deliveryDate = $('#' + valueOption).attr('data-delivery_date');
        $this.find('.c-Variants__delivery_date').text(deliveryDate);
    });

    $('.c-Variants__BuyProduct a.c-Variants__AddToCart').on('click', function(e) {
        e.preventDefault();
        var quantity = 1;
        var id = $(this).attr('data-id');
        var deliveryDate = $('#' + id).attr('data-delivery_date');
        var params = {
            type: 'POST',
            url: '/cart/add.js',
            async: false,
            data: 'quantity=' + quantity + '&id=' + id + '&properties[お届け予定日]=' + deliveryDate,
            dataType: 'json',
            success: function() {
                $('.Header__CartDot').addClass('is-visible');
                window.location = '/cart';
            },
            error: function(XMLHttpRequest, textStatus) {
                Shopify.onError(XMLHttpRequest, textStatus);
            }
        };
        jQuery.ajax(params);
    });

    var checkExisPreorderAddTocart = setInterval(function() {
        var $item = $('.ProductForm.preorder-now-active');
        if ($item.length) {
            clearInterval(checkExisPreorderAddTocart);
            $('.c-Variants__BuyProduct a.c-addToCartPreorder').on('click', function(e) {
                e.preventDefault();
                var quantity = 1;
                var id = $(this).parent().parents('.c-Variants').attr('data-variant-id');
                var valuePreorderNote = $('#preorder-note').val();
                var data = {
                    "quantity": 1,
                    "id": id,
                    "properties": {
                        "PN-Note": valuePreorderNote
                    }
                }
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    async: false,
                    data: data,
                    dataType: 'json',
                    success: function() {
                        $('.Header__CartDot').addClass('is-visible');
                        window.location = '/cart';
                    },
                    error: function(XMLHttpRequest, textStatus) {
                        Shopify.onError(XMLHttpRequest, textStatus);
                    }
                });
            });
        }
    }, 100); // check every 100ms
});
  
// 19 June '24: 不具合のためコメントアウト
// Instafeed app customize
// var checkExistInstagram = setInterval(function() {
//     var $item = $('.instafeed-lightbox');
//     if ($item.length) {
       
//         clearInterval(checkExistInstagram);
//         $("#insta-feed h2").addClass('insta-feed__title');
//         $('#insta-feed h2').append('<div class="SectionHeader__Link pc"><a href="https://www.instagram.com/labelleetude_official/" target="_blank" class="pc">FOLLOW US <span>@ labelleetude_official</span></a></div>');
//       	$("#insta-feed").parent().addClass('c-instagram');
//       	$('.c-instagram').append('<div class="SectionHeader__Link sp"><a href="https://www.instagram.com/labelleetude_official/" target="_blank">FOLLOW US <span>@ labelleetude_official</span></a></div>');
//     }
//   }, 100); // check every 100ms

// //slider Gallery
//   function showSliderInstagram (){
//     var checkExistInstagramSlider = setInterval(function() {
//         var $item = $('.instafeed-lightbox');
//         if ($item.length) {
//           clearInterval(checkExistInstagramSlider);
//           if($(window).width() <= 768){
//             $('.c-instagram').append($('.instafeed-lightbox'));
//             $('#insta-feed .slide-page').each(function(){
//               $(this).find('.instafeed-container img').attr("src", $(this).find('.instafeed-container img').data('src'));
//             });
//             setTimeout(function(){
//               $('#insta-feed>div').not(".slick-initialized").slick({
//                 arrows: false,
//                 infinite: true,	
//                 dots: false,
//                 speed: 300,
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 centerPadding: '97px',
//                 centerMode: true
//               });
//             },200)
//           } else{
//             $('#insta-feed>div').hasClass("slick-initialized") && $('#insta-feed>div').slick("unslick")
//           }
//         }
//     }, 100); // check every 100ms
//   }
    

//   showSliderInstagram();
//   $(window).on('resize', function(){
//     showSliderInstagram();
//   });
 	
$('.Product__ActionViewGallery button').click(function(){
	$('.popup-viewGallery').addClass('is-open');
});
$('.popup-viewGallery__header .js-closePopup').click(function(){
	$(this).parents().removeClass('is-open');
});

  $(document).ready(function(){
//     try{
//         FilterApi.afterCall = function(filter) {
//           setTimeout(function() {
//             if($('.Popover__ValueList').length){
//               if($('.sort').length){
//                 $('.sort').find('.sort_by').text($('.Popover__ValueList .Popover__Value.is-selected').text());
//               }
//             }
//           }, 0);
//           var Dropdownfiltersp = setInterval(function(){
//             if($('.boost-pfs-filter-button').length && !$('.boost-pfs-filter-button').hasClass('open')){
//               clearInterval(Dropdownfiltersp);
//               $('.boost-pfs-filter-button').off('click');
//               $('.boost-pfs-filter-button').on('click',function(){
//                 if( $(this).hasClass('close')){
//                   $(this).removeClass('close');
//                   $(this).parents('.boost-pfs-filter-option').find('.boost-pfs-filter-option-title').removeClass('boost-pfs-filter-option-collapsed');
//                   $(this).parent().next().find('.boost-pfs-filter-option-content-inner').slideDown();
//                 }else{
//                   $(this).addClass('close');
//                   $(this).parents('.boost-pfs-filter-option').find('.boost-pfs-filter-option-title').addClass('boost-pfs-filter-option-collapsed');
//                   $(this).parent().next().find('.boost-pfs-filter-option-content-inner').slideUp();
//                 }
//               });
//             }
//           }, 100);
//           if(filter.event_type == 'collection'){
//             location.reload();
//           }
//         }
        
//     }catch(err){
//         //console.log(err);
//     }
  
   //scroll auto play video
  if($('.Section-featured--video').length){
    $(window).scroll(function(e) {
      if (($(window).scrollTop() + $('.Section-featured--video').height()) > $('.Section-featured--video').offset().top){
        setTimeout(function(){
          $('#featured__video button[data-action="open-modal"]').click();
        },500)
      }
    });
  }
  
  if($('.Product__Tabs').length){
    $('.Product__Tabs .Collapsible__Button').click(function(e){
      e.preventDefault();
      $(this).toggleClass('is-active');
      $(this).parent().find('.Collapsible__Inner').slideToggle();
    })
  }
});

// Check apple device
if (navigator.userAgent.indexOf('Mac OS X') != -1) {
  $("body").addClass("u-mac");
}
if($(".Section-ranking-featured--collections").length){
  $( ".Section-ranking-featured--collections .ProductList .ProductItem" ).each(function( index ) {
    var handle=  $(this).find('.ProductItem__ImageWrapper').attr('href');
    var $this = $(this);
    jQuery.getJSON( handle + '.js', function(product) {
      product.tags.map(function(tag){

        if(tag.search('tops') >= 0 ){
          $this.addClass('tops');
        }
        if(tag.search('outer') >= 0){
          $this.addClass('outer');
        }
        if(tag.search('bottoms') >= 0){
          $this.addClass('bottoms');
        }
      });
    } );
  });
  $(".Section-ranking-featured--collections .SectionHeader__HeadingLeft .filter--tab li").on('click', function(){
    var filter = $(this).data('filter');
    $(".Section-ranking-featured--collections .SectionHeader__HeadingLeft .filter--tab li").removeClass('is-active')
    $(this).toggleClass('is-active');

    $(".Section-ranking-featured--collections .slick-slider").slick('slickUnfilter');
    $('.Section-ranking-featured--collections .TabPanel').attr('aria-hidden', true);

    if(filter == 'all'){
//       $(".Section-ranking-featured--collections .slick-slider").slick('slickUnfilter');
      $('.TabPanel[data-tabs-target="ranking"]').attr('aria-hidden', false);
      $('.TabPanel[data-tabs-target="ranking"]  .slick-slider').slick('slickSetOption', {}, true);
    }
    else if(filter == 'outer'){
//       $(".Section-ranking-featured--collections .slick-slider").slick('slickFilter','.outer');
      $('.TabPanel[data-tabs-target="ranking-outer"]').attr('aria-hidden', false);
      $('.TabPanel[data-tabs-target="ranking-outer"]  .slick-slider').slick('slickSetOption', {}, true);
    }
    else if(filter == 'tops'){
//       $(".Section-ranking-featured--collections .slick-slider").slick('slickFilter','.tops');
      $('.TabPanel[data-tabs-target="ranking-tops"]').attr('aria-hidden', false);
      $('.TabPanel[data-tabs-target="ranking-tops"]  .slick-slider').slick('slickSetOption', {}, true);
    }
    else if(filter == 'bottoms'){
//       $(".Section-ranking-featured--collections .slick-slider").slick('slickFilter','.bottoms');
      $('.TabPanel[data-tabs-target="ranking-bottoms"]').attr('aria-hidden', false);
      $('.TabPanel[data-tabs-target="ranking-bottoms"]  .slick-slider').slick('slickSetOption', {}, true);
    }

  })
}

// Sections/blog-posts - Hide if no blog posts
document.addEventListener('DOMContentLoaded', function() {
  var blogpostSection = document.querySelector('.Section--blogpost');
  if (blogpostSection) {
    var articleItems = blogpostSection.querySelectorAll('.ArticleItem');
    if (articleItems.length === 0) {
        blogpostSection.style.display = 'none';
    }
  }
});

// Sections/main-product/block 'related-posts' - Hide if no blog posts
document.addEventListener('DOMContentLoaded', function() {
  var blogpostSection = document.querySelector('.Product__Info-related-posts');
  if (blogpostSection) {
    var articleItems = blogpostSection.querySelectorAll('.Product__Info-related-posts-item');
    if (articleItems.length === 0) {
        blogpostSection.style.display = 'none';
    }
  }
});

// ----------------------------------------
// 商品一覧 お気に入り: PrimeReview用の実装
// ----------------------------------------
window.addEventListener("DOMContentLoaded", () => {

  // カラースウォッチクリック時の処理
  document.querySelectorAll('.ColorSwatch__Radio').forEach((radio) => {
    radio.addEventListener("click", async (event) => {

      // カラースウォッチから情報取得
      const variantId = radio.getAttribute('data-variant_id');
      const favorite = radio.getAttribute('data-favorite');

      // <a>タグの情報更新
      const productItem = radio.closest('.ProductItem');
      const imageWrapper = productItem.querySelector('.ProductItem__ImageWrapper');
      if (imageWrapper) {
        imageWrapper.setAttribute('data-variant_id', variantId);
      }

      // お気に入りボタンの情報更新
      const favButton = productItem.querySelector('.mxpr-fav');
      if (favButton) {
        favButton.setAttribute('data-variant_id', variantId);

        if (favorite === 'on') {
          favButton.classList.remove("mxpr-fav-off");
          favButton.classList.add("mxpr-fav-on");
        } else {
          favButton.classList.remove("mxpr-fav-on");
          favButton.classList.add("mxpr-fav-off");
        }
      }
    });
  });

  // お気に入りボタンクリック時の処理
  const _favorite = window.PrimeReviewFavorite;
  const _favButtons = document.querySelectorAll('.ProductItem .mxpr-fav');
  if (_favButtons.length > 0) {
    _favButtons.forEach((button) => {
      button.addEventListener("click", async (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        target.disabled = true;

        // カラースウォッチの情報更新
        const productItem = button.closest('.ProductItem');
        const colorSwatch = productItem.querySelectorAll('.ProductItem__Info .ColorSwatch__Radio');
        if (colorSwatch.length > 0) {
          colorSwatch.forEach((radio) => {
            if (target.dataset.variant_id == radio.getAttribute('data-variant_id')) {
              if (radio.getAttribute('data-favorite') === 'on') {
                radio.setAttribute('data-favorite', 'off');
              } else {
                radio.setAttribute('data-favorite', 'on');
              }
            }
          });
        }

        // お気に入り追加・削除送信
        if (target.classList.contains("mxpr-fav-off")) {
          target.classList.remove("mxpr-fav-off");
          target.classList.add("mxpr-fav-loading");
          await _favorite.submitFavorite(target.dataset.product_handle, target.dataset.variant_id, target.dataset.customer_id);
          target.classList.add("mxpr-fav-on");
          target.classList.remove("mxpr-fav-loading");
          target.disabled = false;

        } else {
          target.classList.remove("mxpr-fav-on");
          target.classList.add("mxpr-fav-loading");
          await _favorite.removeFavorite(target.dataset.product_handle, target.dataset.variant_id, target.dataset.customer_id);
          target.classList.add("mxpr-fav-off");
          target.classList.remove("mxpr-fav-loading");
          target.disabled = false;
        }
      });
    });
  }
});

// ----------------------------------------
// 商品詳細 お気に入り: PrimeReview用の実装
// ----------------------------------------
window.addEventListener("DOMContentLoaded", () => {
  const _favorite = window.PrimeReviewFavorite;
  const _favButtons = document.querySelectorAll('.Product__Variants .mxpr-fav');
  if (_favButtons.length > 0) {
    _favButtons.forEach((button) => {
      button.addEventListener("click", async (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        target.disabled = true;
        if (target.classList.contains("mxpr-fav-off")) {
          target.classList.remove("mxpr-fav-off");
          target.classList.add("mxpr-fav-loading");
          await _favorite.submitFavorite(target.dataset.product_handle, target.dataset.variant_id, target.dataset.customer_id);
          target.classList.add("mxpr-fav-on");
          target.classList.remove("mxpr-fav-loading");
          target.disabled = false;
        } else {
          target.classList.remove("mxpr-fav-on");
          target.classList.add("mxpr-fav-loading");
          await _favorite.removeFavorite(target.dataset.product_handle, target.dataset.variant_id, target.dataset.customer_id);
          target.classList.add("mxpr-fav-off");
          target.classList.remove("mxpr-fav-loading");
          target.disabled = false;
        }
      });
    });
  }
});
